import { toTitleCase } from 'src/util/string';
import { DEFAULT_FIELD_VALUES } from '../../tournaments/form-fields.ts/defaultFieldValues';
import { TextFieldProps } from '@mui/material/TextField';
import { ValueWrapper } from 'src/components/data-entry-ui/ValueWrapper';

export type PrimitiveField = {
  fieldName: string;
  regex?: RegExp;
  regexExplained?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  required?: boolean;
  label?: string;
  textfieldProps?: TextFieldProps;
};

export function createPrimitiveField({
  fieldName,
  regex,
  regexExplained,
  value,
  required,
  label,
  textfieldProps,
}: PrimitiveField): ValueWrapper<typeof value> {
  return {
    [fieldName]: {
      value: value ?? DEFAULT_FIELD_VALUES[String(fieldName)],
      label: label ?? toTitleCase(fieldName),
      regex,
      regexExplained,
      required,
      ...textfieldProps,
    },
  };
}
